export default __webpack_public_path__ + "static/media/datte.71f1aede.webp";